import { render, staticRenderFns } from "./coupons.vue?vue&type=template&id=260238d5&scoped=true&lang=pug&"
import script from "./coupons.vue?vue&type=script&lang=js&"
export * from "./coupons.vue?vue&type=script&lang=js&"
import style0 from "./coupons.vue?vue&type=style&index=0&id=260238d5&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260238d5",
  null
  
)

export default component.exports